import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SignatureJourneys() {
  const contentBlocks = [{
    title: "Expert Storytelling:\xA0No Yawns Here!",
    text: "We understand that the heart of travel is storytelling. Ken, with his extensive experience in crafting impactful stories, narrates the tales behind each historical site in Israel. The narrative depth transforms your trip into an immersive experience that connects you with the very soul of this ancient land."
  }, {
    title: "Customized Meaningful Experiences",
    text: "Unlock doors to private sites and meet local experts who bring history to life. Our deep-rooted local connections ensure you see what others miss, creating truly ",
    highlight: "unforgettable memories."
  }, {
    title: "Engaging and Fun!",
    text: "Travel should also be fun! So we mesh awe and reflection, with laughter and joy. You will leave you with cherished memories and a deeper understanding of this remarkable land, and a smile :)."
  }];
  return <section id="signaturejourneys" className="bg-background py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className="relative h-full min-h-[400px] w-full overflow-hidden rounded-lg lg:min-h-[600px]">
            <img src="https://humble-drake.10web.cloud/wp-content/uploads/2026/02/Chen.jpg" alt="Travelers enjoying a scenic view of Jerusalem" className="h-full w-full object-cover" />
          </div>

          {}
          <div className="flex flex-col justify-center space-y-10">
            <h2 className="text-4xl font-bold tracking-tight text-primary sm:text-5xl">Why Choose Us?</h2>

            <div className="space-y-8">
              {contentBlocks.map((block, i) => <div key={i} data-index={i} className="space-y-3">
                  <h3 className="text-xl font-bold text-foreground">
                    {block.title}
                  </h3>
                  <p className="text-lg leading-relaxed text-muted-foreground">
                    {block.text}
                    {block.highlight && <span className="font-bold text-ring">
                        {block.highlight}
                      </span>}
                  </p>
                </div>)}
            </div>

            
          </div>
        </div>
      </div>
    </section>;
}